/** Parse the whole entry exactly: malformed or over-precise text must never become a different refund quantity. */
export function parseReturnQuantity(text: string): number | null {
  const value = text.trim();
  if (!value) return 0;
  if (!/^(?:\d+(?:\.\d{0,3})?|\.\d{1,3})$/.test(value)) return null;
  const [whole = '0', fraction = ''] = value.split('.');
  const milli = Number(whole) * 1000 + Number(fraction.padEnd(3, '0'));
  return Number.isSafeInteger(milli) ? milli : null;
}
